// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__T9dnW","loading":"style_loading__VC9S9","container":"style_container__K+3gF"};